import { useContext } from 'react';

import { HistoricalRouteContext } from '../contexts/historical-route';
import { HistoricalRouteContextProps } from '../contexts/historical-route/types';

export function useHistoricalRoute(): HistoricalRouteContextProps {
    return useContext(HistoricalRouteContext);
}
